// extracted by mini-css-extract-plugin
module.exports = {"icon":"CountryIcon__icon___2JDuW","xs":"CountryIcon__xs___AyMNq","sm":"CountryIcon__sm___uKVIu","lg":"CountryIcon__lg___1HrkA","xl":"CountryIcon__xl___30gjf"};